var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDribbbleLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.1 2.8c2.6 2.13 4.47 4.17 5.7 6.32m0 0a14.12 14.12 0 0 1 1.68 4.54m-1.67-4.54c1.8-.91 3.52-2.2 5.22-3.94m-5.22 3.94c-3.37 1.69-7.03 2-11.4 1.2m13.07 3.34c.43 2.3.34 4.84-.17 7.78m.17-7.78c-3.1.88-5.94 2.84-9.05 6.13m9.05-6.13c1.98-.55 4.05-.67 6.35-.4m-6.52 8.18-.01.06m.01-.06A10 10 0 1 0 8.68 2.56a10 10 0 0 0 6.63 18.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDribbbleLine);
export default __webpack_public_path__ + "static/media/dribbble_line.115302de5e07b0c168232daf4fed0aaf.svg";
export { ForwardRef as ReactComponent };